import type { RootState } from 'typesafe-actions';
import type { ProductOwnProps } from './product.types';
import { BasketFlowActions, getBasket, getBasketLoading } from 'features/basket';
import type { Dispatch } from 'redux';
import {
  ADD_TO_SHOPPING_LIST_REQUEST,
  REMOVE_FROM_SHOPPING_LIST_REQUEST,
} from 'features/products/ducks/shopping-list';
import type { BasketItem } from 'features/basket/types';
import { getShoppingListCookie } from 'features/products/ducks/selectors';

export const mapStateToProps = (state: RootState, ownProps: ProductOwnProps) => {
  const basket = getBasket(state);
  const isBasketLoading = getBasketLoading(state);
  const { product } = ownProps;
  const cartEntity = basket.find((e: { code: string }) => e.code === product.productId);
  const inBasket = !!cartEntity;
  const qty = cartEntity?.quantity;
  const shoppingListCookie = getShoppingListCookie(state);
  const inShoppingList = !!shoppingListCookie?.includes(product.productId);
  return { inBasket, qty, inShoppingList, isBasketLoading };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  addToBasket: (code: string, quantity: number) => {
    dispatch(BasketFlowActions.UPDATE_ITEM({ quantity, code }));
  },
  addToShoppingList: (id: string) => dispatch(ADD_TO_SHOPPING_LIST_REQUEST(id)),
  updateCartItem: (code: string, quantity: number) =>
    dispatch(BasketFlowActions.UPDATE_ITEM({ quantity, code })),
  loadBasket: () => dispatch(BasketFlowActions.LOAD()),
  updateBasket: (basket: BasketItem[]) => dispatch(BasketFlowActions.UPDATE(basket)),
  removeFromBasket: (code: string) => {
    dispatch(BasketFlowActions.RESET_ITEM({ code }));
  },
  removeFromShoppingList: (id: string) => dispatch(REMOVE_FROM_SHOPPING_LIST_REQUEST(id)),
});
